
<script>
import { PLANBOOK_PAGE_MAP } from '@/config/assets'
import { clause, clauseSwitch, getPublicClause } from '@/api/index'
import ToggleDesc from '@/components/toggleDesc/toggleDesc'
import { Popup } from 'bxs-ui-vue'

const SHOW_MIN_NUMBER = 2
export default {
  name: 'InsuranceClause',
  components: {
    ToggleDesc,
    [Popup.name]: Popup
  },
  props: {
    miniprogram: {
      type: Boolean,
      default: false
    },
    isPublic: {
      type: Boolean,
      default: false
    },
    uuid: {
      type: String,
      default: ''
    },
    listData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    // 视图开关
    this.isSpecialView = true
    return {
      isShow: false,
      list: [],
      isSupportShow: false
    }
  },
  computed: {
    preData () {
      const { listData, list } = this
      return list.length ? list : listData
    },
    showData () {
      const { preData, isShow, isNumberStandard } = this
      if (!Array.isArray(preData)) return []
      const validData = preData.filter(item => item.clauseUrl)
      return isNumberStandard
        ? isShow
          ? validData
          : validData.slice(0, SHOW_MIN_NUMBER)
        : validData
    },
    isNumberStandard () {
      const { preData } = this
      return Array.isArray(preData) && preData.length > SHOW_MIN_NUMBER
    }
  },
  created () {
    // this.init()
    if (this.uuid) {
      this.fetchData()
    }
  },
  methods: {
    async init () {
      try {
        const {
          data: { data }
        } = await this.checkSpecialView()
        this.isSpecialView = !!data
      } catch (er) {
        console.log(er)
      }
    },
    fetchData () {
      const { isPublic, uuid } = this
      const fetchAjax = isPublic ? getPublicClause : clause
      fetchAjax({ uuid }).then(({ data: { success, data } } = { data: {} }) => {
        if (!success) return
        this.list = data
      })
    },
    checkSpecialView () {
      return clauseSwitch()
    },
    checkLegalDomain (address) {
      return /\.winbaoxian\.cn|\.winbaoxian\.com/.test(address)
    },
    checkPdfFile (address) {
      const index = address.lastIndexOf('.')
      const ext = address.substr(index + 1)
      return ext.toLocaleLowerCase() === 'pdf'
    },
    handleViewClause ({ clauseUrl, xcxClauseUrl, name }) {
      // 小程序 && 无小程序地址 && 外链域名 -> 限制提示
      // 小程序 && 小程序特定条款字段 && pdf格式 -> pdf 预览页
      if (
        this.miniprogram &&
        !xcxClauseUrl &&
        !this.checkLegalDomain(clauseUrl)
      ) {
        this.isSupportShow = true
        return
      }
      let viewURL = clauseUrl
      if (xcxClauseUrl) {
        if (this.checkPdfFile(xcxClauseUrl)) {
          viewURL = `${PLANBOOK_PAGE_MAP.pdfViewer}?file=${encodeURIComponent(
            xcxClauseUrl
          )}`
          if (name) {
            viewURL += `&title=${name}`
          }
        } else {
          viewURL = xcxClauseUrl
        }
      }
      location.href = viewURL
    }
  }
}
</script>
<template>
  <div v-if="showData.length" class="insurance-clause">
    <div class="clause-main">
      <h3 class="after-bd-b">
        条款详情
      </h3>
      <div class="clause-bd">
        <div v-for="(item, index) in showData" :key="index" class="clause-item">
          <div class="clause-title">
            <p>{{ item.fullName }}</p>
          </div>
          <div class="clause-action">
            <a
              v-if="item.clauseUrl"
              href="javascript:;"
              class="after-bdr"
              data-stat-id="tkxq_yw"
              @click="handleViewClause(item)"
            >原文</a>
          </div>
        </div>
        <toggle-desc
          v-if="isNumberStandard"
          class="normal-toggle"
          @toggle="isShow = !isShow"
        />
      </div>
    </div>

    <bxs-popup
      v-model="isSupportShow"
      class="not-support-miniprogram"
      :close-on-click-overlay="false"
    >
      <div class="tips">
        由于小程序域名限制，暂不支持查看该条款，请下载使用保险师app
      </div>
      <div class="btn" @click="isSupportShow = false">
        知道了
      </div>
    </bxs-popup>
  </div>
</template>
<style lang="postcss" scoped>
@import 'variable.css';

.insurance-clause {
  @apply --widthcenter;
  margin-bottom: 0.2rem;
  border-radius: 6px;
  background-color: #fff;
}

.clause-main {
  > h3 {
    position: relative;
    padding: 0.26rem 0;
    font-size: 0.34rem;
    font-weight: 700;
    text-align: center;
  }
  .clause-bd {
    padding: 0.3rem;
  }
}

.clause-item {
  display: flex;
  padding-left: 0.3rem;
  font-size: 0.32rem;
  &:not(:last-of-type) {
    margin-bottom: 0.3rem;
  }
  .clause-title {
    flex: 1;
    position: relative;
    &::before {
      content: '';
      position: absolute;
      left: -10px;
      top: 8px;
      border-width: 3px;
      border-style: solid;
      border-radius: 50%;
      vertical-align: middle;
    }
    > p {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      color: #333;
    }
  }
  .clause-action {
    width: 1.4rem;
    text-align: right;
    > a {
      z-index: 1;
      display: inline-block;
      padding: 0 0.2rem 0.06rem;
      font-size: 0.24rem;
      font-weight: normal;
      line-height: 1;
      &::before {
        @apply --extend-click;
      }
      &::after {
        border-radius: 100px;
      }
      &:last-child {
        margin-left: 0.18rem;
      }
    }
  }
}
</style>
<style lang="postcss">
.clause-item {
  .clause-title {
    &::before {
      border-color: var(--theme-primary-color);
    }
  }
  .clause-action {
    > a {
      color: var(--theme-primary-color);
      background-color: #faf9ff;
      &::after {
        border-color: var(--theme-primary-color);
      }
    }
  }
}
</style>


